import React from "react"
import classNames from "classnames"
import ReactTooltip from "react-tooltip"
import {AssignmentItem, AssignmentItemId, AssignmentStage} from "../../../resources/assignments"
import {AssigneeAvatar} from "../../../components/AssigneeAvatar/AssigneeAvatar"
import {AssignmentItemStatus} from "../../../components/AssignmentItemStatus/AssignmentItemStatus"
import {getAssigneeNames} from "../../../components/AssigneeAvatarWithName/AssigneeAvatarWithName"

interface CollapsedAssignmentQueueItemProps {
	item: AssignmentItem
	isSelected: boolean
	onSelect: (id: AssignmentItemId) => void
}

export function CollapsedAssignmentQueueItem({item, isSelected, onSelect}: CollapsedAssignmentQueueItemProps) {
	const showOwnerDot = item.isOwnersItem && item.stage === AssignmentStage.Pending
	const tooltipId = `collapsed-queue-tooltip-${item.id}`

	return (
		<>
			<div
				data-tip
				data-for={tooltipId}
				className={classNames("collapsed-queue-avatar-btn", {
					"is-selected": isSelected,
					"is-completed": item.stage === AssignmentStage.Completed,
				})}
				role="button"
				tabIndex={0}
				onClick={() => onSelect(item.id)}
				onKeyDown={(e) => {
					if (e.key === "Enter" || e.key === " ") {
						e.preventDefault()
						onSelect(item.id)
					}
				}}
			>
				<AssigneeAvatar assignees={item.assignees} size="medium" />
				{showOwnerDot && <span className="collapsed-queue-avatar-dot" />}
			</div>
			<ReactTooltip id={tooltipId} place="right" effect="solid" className="collapsed-queue-tooltip" delayShow={300}>
				<div className="collapsed-queue-tooltip-status">
					<AssignmentItemStatus status={item.status} />
				</div>
				<div className="collapsed-queue-tooltip-title">{item.title}</div>
				<div className="collapsed-queue-tooltip-assignee">{`Assigned to ${getAssigneeNames(item.assignees)}`}</div>
			</ReactTooltip>
		</>
	)
}
